import { Component, OnInit, EventEmitter, Input, Output, ViewChild, OnChanges, SimpleChanges,Inject,ElementRef,HostListener,OnDestroy, Renderer2 } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
// import { AppService } from '../../app.service';
import { AuthenticationService } from 'src/app/authentication/authentication.service';
import { AuthenticationComponent } from 'src/app/authentication/authentication.component';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ApiService } from 'src/app/pages/common/api.service';
import { GlobalConstants } from 'src/app/pages/common/global-variables';
import { HttpClient } from '@angular/common/http';
import { Location,DOCUMENT } from '@angular/common';
import { environment } from 'src/environments/environment';

import { BsModalService } from 'ngx-bootstrap/modal';
import { SearchComponent } from './search-modal/search-modal.component';
import { AddCardModalComponent } from 'src/app/authentication/addCard-modal/addCard-modal.component';
import { CountryModalComponent } from 'src/app/shared/components/country-modal/country-modal.component';
import { DataTransferService } from 'src/app/shared/services/common/datatransfer.service';
import { AESEncryptDecryptService } from 'src/app/authentication/encryption/AESEncryptDecryptService.service';
import { ToastrService } from 'ngx-toastr';
import { PixelService } from 'ngx-pixel';

@Component({
  selector: 'app-header',
  templateUrl: 'header.component.html',
  styleUrls: ['header.component.scss'],
  providers: [ApiService,GlobalConstants]
})
export class HeaderComponent implements OnInit, OnChanges,OnDestroy {
  projectSubscription: Subscription;
  reloadSubscription: Subscription;
  @Input() showProfileDropDown: any = false;
  @Input() showAuthentication: boolean = false;
  @Output() hideProfileDropDown = new EventEmitter<any>();

  @Output() reloadTemplate = new EventEmitter();
  @Input() refreshHeader: boolean = false;
  @Input() milestoneRewardsExists: boolean = false;
  @Input() selectedCategory;
  @ViewChild(AuthenticationComponent) authC: AuthenticationComponent;
  modalRef;
  IDLE_TIMEOUT = 900;
  _idleSecondsTimer = null;
  _idleSecondsCounter = 0;
  // showAuthentication: any = false;
  openHamburger = false;
  deviceInfo = null;
  isMobile: boolean = false;
  isTablet: boolean = false;
  isDesktopDevice: boolean = false;
  isLoggedIn: boolean = false;
  modalOpen: any = false;
  openMenu: any = false;
  openMenuMob: any = false;
  modalOpenMob: any = false;
  userCards: any = [];
  activeCard: any 

  hideHeader: boolean = false;
  public templateNum: number = 1;
  currentUserCard: any;

  activeCardType: any;
  environment_type: any;
  isBangladesh = false;
  currentProject: any;
  public projectCode: string = '';
  public hideLocation: boolean = false;
  public hideSearch: boolean = false;

  @HostListener('unloaded')
  ngOnDestroy() {
    this.dataTransferService.nextMessage(null)
    if(this.projectSubscription){
      this.projectSubscription.unsubscribe()
    }
    if(this.reloadSubscription){
      this.reloadSubscription.unsubscribe()
    }
    this.elementRef.nativeElement.remove();
  }
  removeSubscriptions(){
    if(this.projectSubscription){
      this.projectSubscription.unsubscribe()
    }
    if(this.reloadSubscription){
      this.reloadSubscription.unsubscribe()
    }
  }
  @HostListener('window:resize', ['$event'])
  onResize() {
    if (window.innerWidth > 1024) {
      this.isDesktopDevice = true;
      this.isTablet = false;
      this.isMobile = false;
      // this.ngOnInit();
    }
    else if (window.innerWidth > 768) {
      this.isDesktopDevice = false;
      this.isTablet = true;
      this.isMobile = false;
      // this.ngOnInit();
    }
    else {
      this.isDesktopDevice = false;
      this.isTablet = false;
      this.isMobile = true;
      // this.ngOnInit();
    }
    // this.innerWidth = window.innerWidth;
  }
  constructor(
    private router: Router,
    public _apiService: ApiService,
    public GlobalConstants: GlobalConstants,
    private authenticationService: AuthenticationService,
    private dataTransferService: DataTransferService,
    private location: Location,
    private route: ActivatedRoute,
    private modalService: BsModalService,
    @Inject(DOCUMENT) private document: any,
    private _AESEncryptDecryptService: AESEncryptDecryptService,
    private toastr: ToastrService,
    private elementRef: ElementRef,
    private _renderer2: Renderer2,
    private pixel: PixelService
  ) {
    // this.addAnalytics();
    this.deviceCheckFunction();
    this.onResize();
    this.environment_type = this.document.location.hostname.includes("sandbox") ? 'sandbox' : 'prod';
    this.setProjectCode();
  }

  private setProjectCode() {
    let pathName = this.document.location.pathname.split('/',3);
    this.projectCode = pathName ? pathName[1] : '';
  }

  skipLocation() {
    let pathname = this.document.location.pathname.split('/',3);
    return this.GlobalConstants.sub_projects_to_skip_location.includes(pathname[1]);
  }

  ngOnInit() {
    this.checkAuth();
    this.checkCountry();
    if(this.skipLocation()) {
      this.getProjects(this.GlobalConstants.data.x_header[this.environment_type].main_project);
    } else {
      this.getInternationalGeoLocation();
    }
    this.updateConditionalFlags();
    // this.removeSubscriptions();
    if(!this.reloadSubscription){
      this.reloadSubscription = this.dataTransferService.sharedReloadEvent.subscribe(res => {
        if(res){
          console.log('reload head');
          this.checkAuth();
          this.checkCountry();
          this.updateConditionalFlags();
          this.getProjects(this.GlobalConstants.data.x_header[this.environment_type].main_project);
        }
      });
    }

  }

  private updateConditionalFlags() {
    this.hideLocation = this.skipLocation();
    this.hideSearch = this.document.location.pathname.includes('visa-times-prime');
  }

  checkCountry(){
    if(localStorage.getItem("userCountry")){
      this.userCountry = JSON.parse(localStorage.getItem('userCountry'))
      if(!this.userCountry.attributes){
        this.userCountry['attributes'] = this.userCountry;
      }
    }
  }
  checkAuth(){
    if (localStorage.getItem("currentUser")) {
      this.isLoggedIn = true;
      if (localStorage.getItem('selectedCardType')) {
        this.activeCardType = localStorage.getItem('selectedCardType')
      }
      this.getCards();
    } else {
      this.clearAuthStorage()
      this.isLoggedIn = false;
    }
    if (JSON.parse(localStorage.getItem('card_verified')) == false) {
      this.clearAuthStorage()
    }
  }
  clearAuthStorage(){
    localStorage.removeItem('currentUser');
    localStorage.removeItem('card_verified');
    localStorage.removeItem('cardSelected');
    localStorage.removeItem('userCard');
    localStorage.removeItem('uc');
    localStorage.removeItem('userCards');
    localStorage.removeItem('redirectData');
    localStorage.removeItem('headerLogin');
    localStorage.removeItem('thebin');
    localStorage.removeItem('selectedCardType');
  }
  getCards(isReload = false) {
    // var userCards = JSON.parse(localStorage.getItem("userCards"));
    if(this.userCards && this.userCards.length > 0 && !isReload){
      this.checkSelectedCard();
    }
    else{
      this._apiService.getCards().subscribe(
        (res: any) => {
          this.userCards = res.data;
          if(this.userCards.length > 1){
            this.dataTransferService.nextUserCards(res.data);
          } else {
            this.dataTransferService.nextUserCards([res.data]);
          }
          // localStorage.setItem("userCards", JSON.stringify(this.userCards));
          this.checkSelectedCard();


        },
        (err) => {

        }
      );
    }
  }
  checkSelectedCard(){
    if (localStorage.getItem('uc') && localStorage.getItem('uc') != 'undefined') {
      let usercard = localStorage.getItem('uc');
      this.activeCard = this.userCards.filter((item) => item.id === usercard)[0] ;
      
      this.currentUserCard = usercard;

      this.userCards.forEach((x) => {
        if (this.currentUserCard && (x.id == this.currentUserCard)) {
          x['currentCard'] = true;
        } else {
          x['currentCard'] = false;
        }
      });
      // var first = "role";
      this.userCards.sort(function(x,y){ return x.currentCard ? -1 : y.currentCard ? 1 : 0; });
    }
  }
  deviceCheckFunction() {
    // this.deviceInfo = this.deviceService.getDeviceInfo();
    // this.isMobile = this.deviceService.isMobile();
    // this.isTablet = this.deviceService.isTablet();
    // this.isDesktopDevice = this.deviceService.isDesktop();
  }




  checkRedirect(){
      let redirectData = JSON.parse(localStorage.getItem('redirectData'));
        const rederectProject = this.specialProjects.find((x) => { return x.id === redirectData.id })
        if(rederectProject && rederectProject.id){
          localStorage.removeItem('redirectData');
          this.router.navigate([rederectProject.attributes.code, 'offers']);
        }
        else {
          localStorage.removeItem('redirectData');
        }
  }
  reloadInit() {
    this.ngOnInit();
    this.getCards(true);
    this.reloadTemplate.emit();

  }

  ngDoCheck() {
    if (localStorage.getItem("currentUser")) {
      this.isLoggedIn = true;
    } else {
      this.isLoggedIn = false;
    }
  }

  backClicked() {
    this.location.back();
  }


  login(project?) {
    if(project){
      project['projectId'] = project.id;
      localStorage.setItem('redirectData', JSON.stringify(project));
    }
    else{
      localStorage.setItem('headerLogin', 'true');
    }
    this.authC.restartLogin();
  }

  hideAuthentication() {
    this.showAuthentication = false;
  }

  private reloadInHomepage() {
    this.authenticationService.logout();
    window.location.reload();
  }

  logout() {
    this.authenticationService.deleteToken().subscribe((res) => {
      this.reloadInHomepage();
    }, (error) => {
      this.reloadInHomepage();
    });
  }

  setCurrentUserCards(card) {
    // localStorage.setItem("userCard", JSON.stringify(card));
    let currentCardId = localStorage.getItem("uc");
    if(card.id != currentCardId) {
      this.validateCard(card.attributes.bin, card.attributes.bin_type);
    }
    // window.location.reload();
  }

  validateCard(bin, bin_type) {
    this._apiService.validateCard(bin, bin_type).subscribe(res => {
      if (res && res.data && res.data.attributes.bin == bin && (res.data.attributes.status == 'bin_verified' || res.data.attributes.status == 'payment_verified')) {
        // let current_user = JSON.parse(localStorage.getItem("currentUser"));
        // current_user.token = this._AESEncryptDecryptService.encrypt(res.data.attributes.session_token);
        // localStorage.setItem('currentUser', JSON.stringify(current_user));
        localStorage.setItem('card_verified', "true");
        localStorage.setItem('uc', res.data.id);
        // location.reload();
        this.toastr.warning("Selected card is not eligible for the offer");
        // location.href = '';
      }
      else {
        localStorage.setItem('card_verified', "false");
      }
    })
  }

  headerTimeout: any;
  ngOnChanges(change) {



  }
  enableRouterReload(toReload){
    // if(toReload){
    //   this.router.routeReuseStrategy.shouldReuseRoute = function () {
    //       return false;
    //   }
    //   this.router.onSameUrlNavigation = 'reload';
    // }
    // else{
    //   this.router.routeReuseStrategy.shouldReuseRoute = function () {
    //       return true;
    //   }
    //   this.router.onSameUrlNavigation = 'ignore';
    // }
  }
  projects:any;
  specialProjects = [];
  specialProjectsDisp = [];
  message:any;
  getProjects(id) {
    this._apiService.getProjects(id).subscribe(
      (res: any) => {
        if(res.data && res.data.attributes){
          this.specialProjectsDisp = [];
          this.specialProjects = res.data.attributes.sub_projects.data;
          if(res.data.attributes.sub_projects.data.length > 0){
            res.data.attributes.sub_projects.data.forEach(obj =>{
              if(obj.attributes.code != 'visa-infinite' && obj.attributes.code != 'visa-niyo'){
                this.specialProjectsDisp.push(obj);
              }
            })
          }
          this.projects = res.data.attributes;
          let refArr = ['visa-spotify', 'visa-platinum', 'visa-uco-bank', 'visa-iob', 'visa-boi' ,'visa-idbi', 'visa-fyp-money', 'visa-money-view', 'visa-uni', 'visa-akudo'];
          this.specialProjectsDisp.sort(function(a, b){  
            return refArr.indexOf(a.attributes.code) - refArr.indexOf(b.attributes.code);
          });
          // console.log(this.specialProjectsDisp)
          // if(this.projects.sub_projects){
            this.dataTransferService.nextMessage(this.projects)
          // }
          if(this.specialProjects && this.specialProjects.length > 0 && localStorage.getItem('redirectData') && this.isLoggedIn){
            this.checkRedirect();
          }
          else{
            localStorage.removeItem('redirectData');
          }
        }


      },
      (err) => {
        this.toastr.error('Something went wrong!','', {
          timeOut: 6000,
        });

      }
    );
  }

  resetShowProfileDropDown() {
    this.hideProfileDropDown.emit(false);
  }

  openSearchModal() {
    const initialState = {
      features: ['All Offers', 'Offers Near Me']
    }
    var config = {
      backdrop: true,
      ignoreBackdropClick: false
    };
    this.modalRef = this.modalService.show(SearchComponent, Object.assign({}, config, { initialState }));
    this.modalRef.content.searchItemEvent.subscribe(res => {

    })
    this.modalRef.content.selectedItemEvent.subscribe(res => {
      if (res) {
        this.modalRef.hide();
        const merchant = res.item;
        if(merchant.res_type.type === 'parent'){
          this.router.navigate(['/offer/offer-details/' + merchant.id + '/all/' + (merchant.attributes.name ? merchant.attributes.name.split(' ').join('-').split(',').join('').split('(').join('').split(')').join('').toLowerCase() : '')]);
        }
        else if(merchant.res_type.type === 'special'){
          this.projects.sub_projects.data.forEach(obj => {
            if(obj.attributes.code === merchant.res_type.path[1]){
                this.router.navigate([merchant.res_type.path[1], 'offers', obj.attributes.merchants.find((x) => { return x.id === merchant.id }).code]);
            }
          })
        }
      }
    })
    this.modalRef.content.hideEvent.subscribe(res => {
      if (res) { this.modalRef.hide(); }
    })
  }

  getMerchants(name) {

  }

  openAddcardModal() {
    var config = {
      backdrop: true,
      ignoreBackdropClick: false
    };
    this.modalRef = this.modalService.show(AddCardModalComponent, Object.assign({}, config, { }));
    this.modalRef.content.hideEvent.subscribe(res => {
      if (res) { this.modalRef.hide(); }
    })
  }

  //international logic starts
  showLocationError:any;
  userLocation: any;
  userCountry: any;
  allInternationalCountries = [];
  allCountries:any;
  getInternationalGeoLocation() {

    this.route.paramMap.subscribe( paramMap => {
      this.isBangladesh = (paramMap.get('code') && paramMap.get('code').includes('islamic-banking')) ? true : false;
      if(!localStorage.getItem("userCountry")){
        if (!this.allInternationalCountries || (this.allInternationalCountries && this.allInternationalCountries.length < 2)) {
          if(!this.isBangladesh){
            this.getAllInternationalCountries();
          }
          else{
            this.getAllInternationalCountries(false,false,true);
          }

        }
        else{
          if(!this.isBangladesh){
            this.checkLocation();
          }
          else{
            if(!localStorage.getItem("allCountries")){
              localStorage.setItem("allCountries", JSON.stringify(this.allInternationalCountries));
            }
            this.checkBangladesh();
          }
        }
      }
      else{
        this.checkCountry()
        let userCountry = JSON.parse(localStorage.getItem("userCountry"));
        if(this.isBangladesh && userCountry.attributes.name.toLowerCase() !== 'bangladesh'){
          this.checkBangladesh()
        }
        else{
          this.callProjects()
        }
      }

  })

    // this.isBangladesh = (this.route.snapshot.params.code && this.route.snapshot.params.code.includes('islamic-banking')) ? true : false;
  }
  checkBangladesh(){
    let allCountries = JSON.parse(localStorage.getItem("allCountries"));
    if(allCountries){
      this.userCountry = allCountries.find(
        (obj) =>
          obj.attributes.name.toLowerCase() === 'bangladesh'
      );
      localStorage.setItem("userCountry", JSON.stringify(this.userCountry));
      this.callProjects()
      location.reload();
    }
    else{
      this.getAllInternationalCountries(false,false,true);
    }
  }
  callProjects(){
    this.getProjects(this.GlobalConstants.data.x_header[this.environment_type].main_project);
  }
  getAllInternationalCountries(checkLocation = true, openLocationModal = false, saveAllCountries = false) {
    this._apiService.getAllCountries().subscribe(
      (res: any) => {
        this.allInternationalCountries = res.data;
        this.allInternationalCountries.sort(function (a, b) {
          var textA = a.attributes.name.toUpperCase();
          var textB = b.attributes.name.toUpperCase();
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        });
        this.dataTransferService.nextCountries(this.allInternationalCountries)
        if(checkLocation){
          this.checkLocation();
        }
        if(openLocationModal){
          this.showLocationModal();
        }
        if(saveAllCountries){
          localStorage.setItem("allCountries", JSON.stringify(this.allInternationalCountries));
          this.checkBangladesh();
        }
        // this.allCountries = res.data;

      });
  }


  checkLocation(){
    if (localStorage.getItem("userLocation")) {
      this.userLocation = JSON.parse(localStorage.getItem("userLocation"));
      this.checkCordinates(this.userLocation.latitude + ',' + this.userLocation.longitude);
    }
    else if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        console.log(position)
        this.userLocation = position.coords;
        localStorage.setItem("userLocation", JSON.stringify({ latitude: position.coords.latitude, longitude: position.coords.longitude }));
        this.checkCordinates(this.userLocation.latitude + ',' + this.userLocation.longitude);
      }, () => {
        // this.showLocationModal(false);
        this.getIpStackLocation();
      });
    } else {
      // this.showLocationModal(false);
      this.getIpStackLocation();
    }
  }
  checkCordinates(param) {
    this._apiService.checkCordinates(param).subscribe(
      (res: any) => {
        if (res && res.results[0] && res.results[0].components) {
            let county;
            let country = res.results[0].components.country.toLowerCase();
            if (res.results[0].components.county) {
              county = res.results[0].components.county.toLowerCase();
            }
            else if (res.results[0].components.county) {
              county = res.results[0].components.city.toLowerCase();
            }
            else if (res.results[0].components.county) {
              county = res.results[0].components.state.toLowerCase();
            }
            this.processLocation({county:county, country:country});
        } else {
          this.showLocationModal(false);
        }
      },
      () => {
        this.showLocationModal(false);
      }
    );
  }
  getIpStackLocation(){
    this._apiService.getIpStackLocation().subscribe((res:any) =>{
//     let res = {
//   "ip":"157.45.248.91",
//   "type":"ipv4",
//   "continent_code":"AS",
//   "continent_name":"Asia",
//   "country_code":"IN",
//   "country_name":"India",
//   "region_code":"KA",
//   "region_name":"Karnataka",
//   "city":"Gubbi",
//   "zip":"572223",
//   "latitude":13.321120262145996,
//   "longitude":76.86128997802734,
//   "location":{
//     "geoname_id":1270824,
//     "capital":"New Delhi",
//     "languages":[
//       {
//         "code":"hi",
//         "name":"Hindi",
//         "native":"\u0939\u093f\u0928\u094d\u0926\u0940"
//       },
//       {
//         "code":"en",
//         "name":"English",
//         "native":"English"
//       }
//     ],
//     "country_flag":"https:\/\/assets.ipstack.com\/flags\/in.svg",
//     "country_flag_emoji":"\ud83c\uddee\ud83c\uddf3",
//     "country_flag_emoji_unicode":"U+1F1EE U+1F1F3",
//     "calling_code":"91",
//     "is_eu":false
//   },
//   "time_zone":{
//     "id":"Asia\/Kolkata",
//     "current_time":"2021-07-28T19:30:36+05:30",
//     "gmt_offset":19800,
//     "code":"IST",
//     "is_daylight_saving":false
//   },
//   "currency":{
//     "code":"INR",
//     "name":"Indian Rupee",
//     "plural":"Indian rupees",
//     "symbol":"Rs",
//     "symbol_native":"\u099f\u0995\u09be"
//   },
//   "connection":{
//     "asn":55836,
//     "isp":"Reliance Jio Infocomm Limited"
//   }
// }
      if(res && res.latitude && res.longitude){
        this.userLocation = {
          latitude: res.latitude,
          longitude: res.longitude
        };
        let locObj = {
          state: res.region_name.toLowerCase(),
          county: res.city.toLowerCase(),
          country: res.country_name.toLowerCase(),
          latitude: res.latitude,
          longitude: res.longitude
        }
        this.processLocation(locObj)
      } else {
        this.showLocationModal(false);
      }
    }, (err) => {
      this.showLocationModal(false);
    });
  }
  processLocation(data) {
    this.userCountry = this.allInternationalCountries.find((x) => { return x.attributes.name.toLowerCase() == data.country })
    if (this.userCountry) {
      this.userLocation = data;
      this.userLocation['country'] = this.userCountry;
      localStorage.setItem("userCountry", JSON.stringify(this.userCountry));
      this.getProjects(this.GlobalConstants.data.x_header[this.environment_type].main_project);
      this.dataTransferService.nextReloadEvent(true);

      this._apiService.getAllCities({country_id: this.userLocation.country.id}).subscribe((res: any) => {
        if(res && res.data && res.data.length > 0){
          let userState = res.data.filter((item) => {
            return item.attributes.name.toLowerCase() == this.userLocation.state
          });
          if(userState && userState.length > 0){
            this.userLocation.state = userState[0].attributes;
          }
          localStorage.setItem("userLocation", JSON.stringify(this.userLocation));
        }
        else{
          localStorage.setItem("userLocation", JSON.stringify(this.userLocation));
        }
      });

    }
    else {
      console.log('location process error')
      this.showLocationModal(false);
    }
  }
  processInternationalLocation(locObj) {
    this.userCountry = this.allInternationalCountries.find((x) => { return x.attributes.name.toLowerCase() == locObj.country })
    if (this.userCountry) {
      localStorage.setItem("userCountry", JSON.stringify(this.userCountry));
      this.getProjects(this.GlobalConstants.data.x_header[this.environment_type].main_project);
      // location.reload();
      this.dataTransferService.nextReloadEvent(true)
    }
    else {
      this.showLocationModal(false);
    }
  }
  showLocationModal(allowClose = true){

      const initialState = {
        allCountries: this.allInternationalCountries ? this.allInternationalCountries : null
      }
      var config = {
        backdrop: true,
        ignoreBackdropClick: allowClose ? false : true,
        keyboard : allowClose ? true : false
      };
      this.modalRef = this.modalService.show(CountryModalComponent, Object.assign({}, config, { initialState }));
      this.modalRef.content.hideEvent.subscribe(res => {
        if (res) { this.modalRef.hide(); }
      })


  }


  goTo(project,type){
    if(this.isLoggedIn){
      if(type === 'project'){
        if(project && project.attributes && project.attributes.merchant){
          this.router.navigate(['offer',project.attributes.code]);
        }
        else{
          this.router.navigate([project.attributes.code, 'offers']);
        }
      }
      else if(type === 'home'){
        let qParams: Params = {};
        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: qParams,
            queryParamsHandling: ''
        });
      }
    }
    else{
      this.login(project);
    }
  }
  addAnalytics(){
    if(this.route.snapshot.params.code && this.route.snapshot.params.code ==='spotify'){
      // google pixel
      var headID = document.getElementsByTagName('head')[0];
      var link = document.createElement('script');
      link.src = 'https://www.googletagmanager.com/gtag/js?id=AW-997466364';
      link.async = true;
      headID.appendChild(link);

      let script2 = this._renderer2.createElement('script');
         script2.text = `
         function gtag(){dataLayer.push(arguments)}window.dataLayer=window.dataLayer||[],gtag("js",new Date),gtag("config","AW-997466364");
         `;
       this._renderer2.appendChild(this.document.head, script2);
      let script3 = this._renderer2.createElement('script');
      script3.text = `
      gtag('event', 'conversion', {'send_to': 'AW-997466364/DVykCOyzwIADEPzB0NsD'});
      `;
      this._renderer2.appendChild(this.document.head, script3);

      // facebook pixel
      // this.pixel.initialize();
      // this.pixel.track('PageView', {});


      // let script = this._renderer2.createElement('script');
      //    script.text = `
      //    !function(e,t,n,c,o,a,f){e.fbq||(o=e.fbq=function(){o.callMethod?o.callMethod.apply(o,arguments):o.queue.push(arguments)},e._fbq||(e._fbq=o),o.push=o,o.loaded=!0,o.version="2.0",o.queue=[],(a=t.createElement(n)).async=!0,a.src="https://connect.facebook.net/en_US/fbevents.js",(f=t.getElementsByTagName(n)[0]).parentNode.insertBefore(a,f))}(window,document,"script"),fbq("init","1565150523616028"),fbq("track","PageView");
      //    `;
       // let noscript = this._renderer2.createElement('noscript');
       // noscript.text = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1565150523616028&ev=PageView&noscript=1"/>`;
      // // this._renderer2.appendChild(this.document.head, script);
      // this._renderer2.appendChild(this.document.head, noscript);
      //
      var headID2 = document.getElementsByTagName('head')[0];
      var link2 = document.createElement('script');
      link2.innerHTML = `!function(e,t,n,c,o,a,f){e.fbq||(o=e.fbq=function(){o.callMethod?o.callMethod.apply(o,arguments):o.queue.push(arguments)},e._fbq||(e._fbq=o),o.push=o,o.loaded=!0,o.version="2.0",o.queue=[],(a=t.createElement(n)).async=!0,a.src="https://connect.facebook.net/en_US/fbevents.js",(f=t.getElementsByTagName(n)[0]).parentNode.insertBefore(a,f))}(window,document,"script"),fbq("init","1565150523616028"),fbq("track","PageView");`
      headID2.appendChild(link2);

      var headID3 = document.getElementsByTagName('head')[0];
      var link3 = document.createElement('noscript');
      link3.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1565150523616028&ev=PageView&noscript=1"/>`;
      headID3.appendChild(link3);
    }

  }

  selectSpclBnft(project) {
    let route
    if(project.attributes.merchants?.length === 1) {
      route = `${project.attributes.code}/offers/${project.attributes.merchants[0].code}`
    } else {
      route = `${project.attributes.code}/offers`
    }
    this.router.navigate([route])
  }
  
}
